export const validationMessage = {
  first_name_req: "First name is required",
  last_name_req: "Last name required",
  email_req: "Email is required",
  email_phone_req: "Email or mobile number is required",
  phone_req:"Phone number is required",
  password_req: "Password is required",
  first_name_invalid: "Invalid first name",
  last_name_invalid: "Invalid last name",
  email_invalid: "Invalid email",
  zip_code_invalid: "Invalid zip code",
  phone_no_invalid: "Invalid phone number",
  phone_no_10_digit: "Enter a 10 digit phone number",
  select_duration: "Select duration",
  select_from_date: "Select from date",
  select_to_date: "Select to date",
  from_date_less_than_to_date: "From date should be less than to date",
  to_date_greater_than_from_date: "To date should be greater than from date",
  block_unblock_success: "Video is blocked / unblocked successfully",
  movie_name_invalid: "Enter a valid movie name",
  unblock_success: "Video is unblocked successfully",
  block_success: "Video is blocked successfully",
  pin_req: "Enter pin to activate device",
  pin_valid: "Enter a valid pin to activate device",
  transaction_id_req: "Enter a transaction id to search",
  transaction_id_required: "Transaction Id is required",
  nextBillingDate_req: "Next billing date is required",
  plan_req: "Plan is required",
  offer_percentage_req: "Offer percentage is required",
  country_req: "Country is required",
  cast_and_crew: "Cast/Crew name is required",
  castcrew_invalid: "Cast/Crew name is invalid",
  castcrew_description: "Description is required",
  cast_image: "Cast/Crew image is required",
  address_req:"address is required",
  state_req:"state is required",
  city_req:"city is required",
  postalCode_req:"Zip/Postal is required"
};

export const errorMessage = {
  something_went_wrong: "Something went wrong, please try again later",
  enter_any_one: "Please enter atleast any one field to search",
  image_error: "Error while uploading images. Please check",
  subtitle_error: "Error while uploading subtitle. Please check",
  upload_file: "Please upload atleast one file to submit",
};
